// jQuery free
(() => { 
	
	const _doWrap = () => {
		const wrapFormElement = (element, wrapperClass) => {
			if( element.parentNode.classList.contains(wrapperClass) ) {
				return;
			}
			const wrapper = document.createElement('span');
			wrapper.classList.add(wrapperClass);
			element.parentElement.insertBefore(wrapper, element);
			wrapper.appendChild(element);
		}
		
		document.querySelectorAll('select').forEach(e => {
			wrapFormElement(e, 'select-box');
			
		});
		
		document.querySelectorAll('input[type=checkbox]').forEach(e => {
			wrapFormElement(e, 'input-checkbox');
		});
		
		document.querySelectorAll('input[type=radio]').forEach(e => {
			wrapFormElement(e, 'input-radio');
		});
		
		
		document.querySelectorAll('input[type=checkbox], input[type=radio]').forEach(input => {
			
			const _onChange = input => {
				const isRadio = input.getAttribute('type') === 'radio';
				//const selector = isRadio ? '.input-radio' : '.input-checkbox';
				//const holder = input.closest(selector);
				
				if( isRadio && input.checked ) {
					const name = input.getAttribute('name');
					document.querySelectorAll('[name='+ CSS.escape(name) +']').forEach(_input => {
						if( input.value !== _input.value &&  _input.getAttribute('type') === 'radio' )
							_input.parentNode.classList.remove('checked');
						
					});
				}
				
				input.checked ? 
					input.parentNode.classList.add('checked') : 
					input.parentNode.classList.remove('checked');
			}
			
	
			input.addEventListener('change', event => {
				_onChange(event.currentTarget);
			});
			
			_onChange(input);
		});
		
		
		const focusClassName = 'has-focus';
		const valueClassName = 'has-value';
		document.querySelectorAll('input, textarea, select').forEach(cpnt => {
			cpnt.addEventListener('focus', () => {
				cpnt.parentElement.classList.add(focusClassName);
			});
			cpnt.addEventListener('blur', () => {
				cpnt.parentElement.classList.remove(focusClassName);
				const hasValue = cpnt.value !== '';
				if(hasValue) {
					cpnt.parentElement.classList.add(valueClassName);
				}
				else {
					cpnt.parentElement.classList.remove(valueClassName);
				}
			});
		});
	}
	
	_doWrap();
	document.addEventListener('pageLoad', () => _doWrap() );
})();




// Exception for WP where jQuery is mandatory...
if(typeof(jQuery) !== 'undefined') {
	jQuery('.wpcf7').on('click', 'label', function() {
		jQuery(this).closest('.field').find('input, textarea, select').first().focus();
	});
}